(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-reviews"] && !Shopify.designMode) return;
  try {
    
  class AdvCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.nav = this.querySelector('.adv-carousel__nav');
      this.dots = this.querySelector('[data-dots]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      this.items = Array.from(this.track.children);
      if (this.items.length < 2 || !this.classList.contains('adv-carousel--carousel')) return;

      this.nav.hidden = false;
      this.dots.replaceChildren(
        ...this.items.map((item, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'adv-carousel__dot';
          dot.setAttribute('aria-label', i + 1 + '. vélemény');
          dot.addEventListener('click', () => this.go(i));
          return dot;
        })
      );
      this.prev.addEventListener('click', () => this.go(this.current - 1));
      this.next.addEventListener('click', () => this.go(this.current + 1));
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    }

    update() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let bestDistance = Infinity;
      this.items.forEach((item, i) => {
        const distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      this.current = best;
      Array.from(this.dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === best)));
      this.prev.disabled = best === 0;
      this.next.disabled = best === this.items.length - 1;
    }

    go(index) {
      const i = Math.max(0, Math.min(this.items.length - 1, index));
      const item = this.items[i];
      this.track.scrollTo({ left: item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
    }
  }

  if (!customElements.get('adv-carousel')) customElements.define('adv-carousel', AdvCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv-topbar"] && !Shopify.designMode) return;
  try {
    
  class AdvCountdown extends HTMLElement {
    connectedCallback() {
      const duration = Math.max(1, Number(this.dataset.seconds) || 0) * 1000;
      const key = this.dataset.key || 'adv-deadline';
      let end = 0;
      try {
        end = Number(localStorage.getItem(key)) || 0;
      } catch (e) {}
      // Each visitor gets their own deadline; it restarts once it has run out
      if (!end || end < Date.now()) {
        end = Date.now() + duration;
        try {
          localStorage.setItem(key, String(end));
        } catch (e) {}
      }
      this.end = end;
      this.parts = { h: this.querySelector('[data-h]'), m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]') };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      const pad = (n) => String(n).padStart(2, '0');
      if (this.parts.h) this.parts.h.textContent = pad(Math.floor(left / 3600));
      if (this.parts.m) this.parts.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (this.parts.s) this.parts.s.textContent = pad(left % 60);
    }
  }

  if (!customElements.get('adv-countdown')) customElements.define('adv-countdown', AdvCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-tabs"] && !Shopify.designMode) return;
  try {
    
  class ReviewTabs extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[role="tabpanel"]');
      this.bar = this.querySelector('.reviews-tabs__bar');
      this.list = this.querySelector('[role="tablist"]');
      if (!this.panel || !this.list) return;

      // One tab per distinct "Fül" value, in the order of the cards
      const groups = new Map();
      this.panel.querySelectorAll('[data-review-tab]').forEach((card) => {
        if (!groups.has(card.dataset.reviewTab)) groups.set(card.dataset.reviewTab, card.dataset.reviewTabLabel || '');
      });

      this.list.replaceChildren();
      let index = 0;
      for (const [value, label] of groups) {
        index += 1;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reviews-tabs__tab';
        button.setAttribute('role', 'tab');
        button.id = this.panel.id + '-tab-' + index;
        button.dataset.tab = value;
        button.textContent = label;
        this.list.append(button);
      }
      this.tabs = Array.from(this.list.children);
      if (this.bar) this.bar.hidden = this.tabs.length < 2;
      this.setAttribute('data-ready', '');
      if (!this.tabs.length) return;

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.select(this.tabs[0], false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onClick = (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (tab) this.select(tab, true);
    };

    onKeydown = (event) => {
      const index = this.tabs.indexOf(document.activeElement);
      if (index < 0) return;
      let next = null;
      if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      if (event.key === 'Home') next = this.tabs[0];
      if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      next.focus();
      this.select(next, true);
    };

    select(tab, animate) {
      const value = tab.dataset.tab;
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      this.panel.setAttribute('aria-labelledby', tab.id);
      this.panel.querySelectorAll('[data-review-tab]').forEach((card) => {
        card.hidden = card.dataset.reviewTab !== value;
      });
      if (animate) {
        const list = this.list;
        const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
        list.scrollTo({ left, behavior: 'smooth' });
      }
      this.panel.scrollLeft = 0;
      if (animate) {
        this.panel.classList.remove('is-switching');
        void this.panel.offsetWidth;
        this.panel.classList.add('is-switching');
      }
    }
  }

  if (!customElements.get('review-tabs')) customElements.define('review-tabs', ReviewTabs);

  } catch(e) { console.error(e); }
})();
})();
